export const appConfig = {
  currency: {
    symbol: '$',
    code: 'USD'
  }
}
